const SERVICE_DATA = {
  heading: "Our Services",
  description:
    "We provide comprehensive SEO services that are tailored to meet the unique needs of our clients.",
  services_list: [
    {
      label: "On-Page SEO",
      text: "Optimize your website's content and structure for search engines.",
      icon: "pe-7s-tools",
    },
    {
      label: "Off-Page SEO",
      text: "Build high-quality backlinks and promote your website to improve its authority.",
      icon: "pe-7s-link",
    },
    {
      label: "Technical SEO",
      text: "Optimize website's technical aspects such as site speed and mobile-friendliness.",
      icon: "pe-7s-display2",
    },
    {
      label: "Local/Global SEO",
      text: "Boost your website's visibility and attract local/global customers.",
      icon: "pe-7s-map-marker",
    },
    {
      label: "E-commerce SEO",
      text: "Optimize your online store to rank higher in search engines and increase sales.",
      icon: "pe-7s-cart",
    },
    {
      label: "Consultation",
      text: "Consult us to get ahead of your competition with our comprehensive analysis.",
      icon: "pe-7s-note2",
    },
  ],
};

const FEATURES_DATA = {
  title:
    "As a SEO practitioner, I have honed my skills to effectively optimize websites.",
  text: "I am passionate about keeping up-to-date with the latest trends and best practices in the field and implementing them in my work. My ultimate objective is to help businesses achieve their objectives by increasing their online visibility, attracting more qualified leads, and ultimately driving more revenue.",
  feature_list: [
    "Committed to staying up-to-date with the latest trends and best practices in the field.",
    "Proficient in using a variety of SEO tools and techniques.",
    "Tracking analytics and performance metrics to measure and improve website performance.",
    
  ],
};

const PRICING_DATA = {
  title: "Our Pricing",
  description:
    "Call to action pricing table is really crucial to your for your business website. Make your bids stand-out with amazing options.",
  pricing_list: [
    {
      title: "Economy",
      price: "$9.90",
      bandwidth: "1GB",
      space: "50MB",
      support: "No",
      domain: 1,
    },
    {
      title: "Delux",
      price: "$19.90",
      bandwidth: "10GB",
      space: "500MB",
      support: "Yes",
      domain: 10,
    },
    {
      title: "Unlimate",
      price: "$29.90",
      bandwidth: "100GB",
      space: "2 GB",
      support: "Yes",
      domain: "Unlimited",
    },
  ],
};

const TEAM_DATA = {
  title: "Behind The People",
  description:
    "It is a long established fact that create category leading brand experiences a reader will be distracted by the readable content of a page when looking at its layout.",
  team_list: [
    {
      profile: "/images/team/img-1.jpg",
      name: "Frank Johnson",
      designation: "CEO",
    },
    {
      profile: "/images/team/img-2.jpg",
      name: "Elaine Stclair",
      designation: "Designer",
    },
    {
      profile: "/images/team/img-3.jpg",
      name: "Wanda Arthur",
      designation: "Developer",
    },
    {
      profile: "/images/team/img-4.jpg",
      name: "Joshua Stemple",
      designation: "Manager",
    },
  ],
};

const TESATIMONIAL_DATA = {
  title: "What they've said",
  description:
    "Join our satisfied clients by experiencing the same level of service and quality. See what they have to say.",
  testimonial_list: [
    {
      profile: "images/testimonials/user-2.jpg",
      description:
        "I feel confident imposing change on myself. It's a lot more fun progressing than looking back. That's why scelerisque pretium dolor, sit amet vehicula erat pelleque need throw curve balls.",
      name: "Ruben Reed - ",
      text: "Charleston",
    },
    {
      profile: "images/testimonials/user-1.jpg",
      description:
        "Our task must be to free ourselves by widening our circle of compassion to embrace all living creatures Integer varius lacus non magna tempor congue natuasre the whole its beauty.",
      name: "Michael P. Howlett - ",
      text: "Worcester",
    },
    {
      profile: "images/testimonials/user-3.jpg",
      description:
        "I've learned that people will forget what you said, people will forget what you did, but people will never aliquam in nunc quis tincidunt forget how you vestibulum egestas them feel.",
      name: "Theresa D. Sinclair - ",
      text: "Lynchburg",
    },
  ],
};

const BLOG_DATA = {
  title: "Blog",
  description:
    "Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean class at a euismod mus ipsum vel ex finibus semper luctus quam.",
  blog_list: [
    {
      image: "images/blog/img-1.jpg",
      text: "UI & UX Design",
      title: "Doing a cross country road trip",
      subtext:
        "She packed her seven versalia, put her initial into the belt and made herself on the way..",
    },
    {
      image: "images/blog/img-2.jpg",
      text: "Digital Marketing",
      title: "New exhibition at our Museum",
      subtext:
        "Pityful a rethoric question ran over her cheek, then she continued her way.",
    },
    {
      image: "images/blog/img-3.jpg",
      text: "Travelling",
      title: "Why are so many people..",
      subtext:
        "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.",
    },
  ],
};

const MOCK_DATA = {
  SERVICE_DATA,
  FEATURES_DATA,
  PRICING_DATA,
  TEAM_DATA,
  TESATIMONIAL_DATA,
  BLOG_DATA,
};

export default MOCK_DATA;
